import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { equipmentByIdQuery } from '@/queries/equipment-by-id.query'
import { equipmentQuery } from '@/queries/equipment.query'

export const Route = createFileRoute('/_dashboard/site/$id/equipment/$equipmentId/_layout/information')({
  parseParams(params) {
    return z
      .object({
        equipmentId: z.string().uuid(),
      })
      .parse(params)
  },
  loaderDeps({ search: { category } }) {
    return { category }
  },
  async loader({ params, context: { queryClient }, deps: { category } }) {
    if (category !== 'cloudConnector') {
      await queryClient.ensureQueryData(equipmentQuery(params.id, params.equipmentId, { action: category }))
    } else {
      await queryClient.ensureQueryData(equipmentByIdQuery(params.id, params.equipmentId))
    }
  },
})
